import React, { memo } from 'react';
import { Box, Flex, Select, Text } from 'pcln-design-system';
const ChildAgeSelect = ({
  className,
  index,
  isHotel,
  value,
  onChange
}) => {
  function handleChange(evt) {
    onChange(index, evt.target.value);
  }
  const ageText = 'yrs';
  const defaultText = 'Age Needed';
  return React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    my: 2
  }, React.createElement(Text, {
    fontSize: 2,
    mr: 1
  }, "Age of Child ", index + 1), React.createElement(Box, null, React.createElement(Select, {
    "aria-label": `Select age for child ${index + 1}`,
    className: className,
    "data-testid": 'child-age-select',
    size: 'md',
    value: value,
    variation: 'subtle',
    onChange: handleChange
  }, React.createElement("option", {
    value: ''
  }, defaultText), React.createElement("option", {
    value: 0
  }, isHotel ? 'Infant' : '0-1 Infant in lap'), React.createElement("option", {
    value: 1
  }, isHotel ? '1 yr' : '0-1 Infant in seat'), React.createElement("option", {
    value: 2
  }, "2 ", ageText), React.createElement("option", {
    value: 3
  }, "3 ", ageText), React.createElement("option", {
    value: 4
  }, "4 ", ageText), React.createElement("option", {
    value: 5
  }, "5 ", ageText), React.createElement("option", {
    value: 6
  }, "6 ", ageText), React.createElement("option", {
    value: 7
  }, "7 ", ageText), React.createElement("option", {
    value: 8
  }, "8 ", ageText), React.createElement("option", {
    value: 9
  }, "9 ", ageText), React.createElement("option", {
    value: 10
  }, "10 ", ageText), React.createElement("option", {
    value: 11
  }, "11 ", ageText), React.createElement("option", {
    value: 12
  }, "12 ", ageText), React.createElement("option", {
    value: 13
  }, "13 ", ageText), React.createElement("option", {
    value: 14
  }, "14 ", ageText), React.createElement("option", {
    value: 15
  }, "15 ", ageText), React.createElement("option", {
    value: 16
  }, "16 ", ageText), React.createElement("option", {
    value: 17
  }, "17 ", ageText))));
};
export default memo(ChildAgeSelect);